<template>
  <div class="lds-ring">
    <div :style="style"></div>
    <div :style="style"></div>
    <div :style="style"></div>
    <div :style="style"></div>
  </div>
</template>

<script>
export default {
  name: "Spinner",
  props: {
    theme: {
      type: String,
      default: "#51B67E"
    },
    size: {
      type: String,
      default: null
    }
  },
  computed: {
    style() {
      const size = this.size;
      var style = { borderTop: `0.125em solid ${this.theme}` };
      switch (size) {
        case "medium":
          style = {
            borderTop: `0.175em solid ${this.theme}`,
            width: "2em",
            height: "2em"
          };
          break;
        case "large":
          style = {
            borderTop: `0.250em solid ${this.theme}`,
            width: "3em",
            height: "3em"
          };
          break;
        default:
          break;
      }
      return style;
    }
  }
};
</script>

<style lang="scss">
.lds-ring {
  display: inline-block;
  position: relative;
  width: 1em;
  height: 1em;
  vertical-align: middle;
  & > div {
    border: 0.125em solid transparent;
    box-sizing: border-box;
    display: block;
    position: absolute;
    width: 1em;
    height: 1em;
    /* margin: 3px; */
    border-radius: 50%;
    animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
    &:first-child {
      animation-delay: -0.45s;
    }
    &:nth-child(2) {
      animation-delay: -0.3s;
    }
    &:last-child {
      animation-delay: -0.15s;
    }
  }
}

@keyframes lds-ring {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
